import { cn } from '@strivelabs/ui-core/lib/utils';
import { avatarColors } from '@strivelabs/ui-blocks/v2';

const initial = (name: string) => name.trim().charAt(0).toUpperCase() || '?';

interface PersonAvatarProps {
  person: { display_name: string; image_url: string | null };
  /** Named on hover where the avatar stands alone, without the name beside it. */
  title?: string;
  className?: string;
}

/**
 * Someone's picture, or their initial on a colour drawn from their name.
 *
 * The colours are the list table's (`avatarColors` in ui-blocks): a pale
 * ground and a dark initial from one of the shared name swatches, picked by
 * name rather than by position, so the same person is the same colour on every
 * surface — a board row, a task panel, a filter menu, a timeline.
 */
export const PersonAvatar = ({ person, title, className }: PersonAvatarProps) => {
  const shared = cn(
    'inline-flex size-[22px] shrink-0 items-center justify-center rounded-full',
    'text-[9.5px] font-semibold',
    className,
  );

  if (person.image_url) {
    return <img src={person.image_url} alt="" title={title} className={cn(shared, 'object-cover')} />;
  }

  return (
    <span
      className={shared}
      style={avatarColors(person.display_name)}
      title={title}
      aria-hidden={title ? undefined : true}
    >
      {initial(person.display_name)}
    </span>
  );
};
